
@file:Suppress("unused")
package tk.mallumo.compose.navigation


import androidx.compose.runtime.remember
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect


object ImplNoteUtils {

    @Composable
    fun navNode(node: NodeInfo) {
        when (node.id) {

            "ui.app.assign.AppAssignListingUI" ->
                composite(node) { ui.app.assign.AppAssignListingUI() }

            "ui.app.assign.detail.AppDetailUI" ->
                composite(node) { ui.app.assign.detail.AppDetailUI() }

            "ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorUI" ->
                composite(node) { ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorUI() }

            "ui.app.assign.detail.kindergarten.preview.AppKindergartenPreviewUI" ->
                composite(node) { ui.app.assign.detail.kindergarten.preview.AppKindergartenPreviewUI() }

            "ui.app.assign.detail.wheel.editor.AppEditorWheelUI" ->
                composite(node) { ui.app.assign.detail.wheel.editor.AppEditorWheelUI() }

            "ui.app.assign.detail.wheel.preview.AppPreviewWheelUI" ->
                composite(node) { ui.app.assign.detail.wheel.preview.AppPreviewWheelUI() }

            "ui.app.rss.AppRssListingUI" ->
                composite(node) { ui.app.rss.AppRssListingUI() }

            "ui.app.rss.channel.AppRssListingChannelUI" ->
                composite(node) { ui.app.rss.channel.AppRssListingChannelUI() }

            "ui.app.rss.instance.AppRssListingInstanceUI" ->
                composite(node) { ui.app.rss.instance.AppRssListingInstanceUI() }

            "ui.app.rss.instance.detail.AppRssDetailInstanceUI" ->
                composite(node) { ui.app.rss.instance.detail.AppRssDetailInstanceUI() }

            "ui.app.visibility.AppVisibilityListingUI" ->
                composite(node) { ui.app.visibility.AppVisibilityListingUI() }

            "ui.campaign.CampaignListingUI" ->
                composite(node) { ui.campaign.CampaignListingUI() }

            "ui.campaign.detailv2.editor.CampaignEditorUI" ->
                composite(node) { ui.campaign.detailv2.editor.CampaignEditorUI() }

            "ui.campaign.detailv2.preview.CampaignPreviewUI" ->
                composite(node) { ui.campaign.detailv2.preview.CampaignPreviewUI() }

            "ui.company.CompanyListingUI" ->
                composite(node) { ui.company.CompanyListingUI() }

            "ui.company.detail.CompanyUI" ->
                composite(node) { ui.company.detail.CompanyUI() }

            "ui.console.ConsoleUI" ->
                composite(node) { ui.console.ConsoleUI() }

            "ui.dashboard.DashboardUI" ->
                composite(node) { ui.dashboard.DashboardUI() }

            "ui.device.DeviceListingUI" ->
                composite(node) { ui.device.DeviceListingUI() }

            "ui.device.detail.editor.DeviceEditorUI" ->
                composite(node) { ui.device.detail.editor.DeviceEditorUI() }

            "ui.device.detail.preview.DevicePreviewUI" ->
                composite(node) { ui.device.detail.preview.DevicePreviewUI() }

            "ui.hardware.HardwareListingUI" ->
                composite(node) { ui.hardware.HardwareListingUI() }

            "ui.hardware.detail.HardwareDetailUI" ->
                composite(node) { ui.hardware.detail.HardwareDetailUI() }

            "ui.home.HomeUI" ->
                composite(node) { ui.home.HomeUI() }

            "ui.EmptyUI" ->
                composite(node) { ui.EmptyUI() }

            "ui.license.LicenseListingUI" ->
                composite(node) { ui.license.LicenseListingUI() }

            "ui.license.detail.LicenseDetailUI" ->
                composite(node) { ui.license.detail.LicenseDetailUI() }

            "ui.location.LocationListingUI" ->
                composite(node) { ui.location.LocationListingUI() }

            "ui.location.detail.LocationUI" ->
                composite(node) { ui.location.detail.LocationUI() }

            "ui.login.LoginUI" ->
                composite(node) { ui.login.LoginUI() }

            "ui.report.campaign.ReportCampaignUI" ->
                composite(node) { ui.report.campaign.ReportCampaignUI() }

            "ui.report.device.ReportDeviceAliveUI" ->
                composite(node) { ui.report.device.ReportDeviceAliveUI() }

            "ui.report.device.ReportDeviceSystemUI" ->
                composite(node) { ui.report.device.ReportDeviceSystemUI() }

            "ui.resource.ResourceListingUI" ->
                composite(node) { ui.resource.ResourceListingUI() }

            "ui.resource.detail.ResourceUI" ->
                composite(node) { ui.resource.detail.ResourceUI() }

            "ui.resource.editor.VisualEditorUI" ->
                composite(node) { ui.resource.editor.VisualEditorUI() }

            "ui.resource.icons.IconsListingUI" ->
                composite(node) { ui.resource.icons.IconsListingUI() }

            "ui.server.ServerListingUI" ->
                composite(node) { ui.server.ServerListingUI() }

            "ui.server.detail.ServerUI" ->
                composite(node) { ui.server.detail.ServerUI() }

            "ui.translation.TranslationListingUI" ->
                composite(node) { ui.translation.TranslationListingUI() }

            "ui.user.UserListingUI" ->
                composite(node) { ui.user.UserListingUI() }

            "ui.user.detail.UserUI" ->
                composite(node) { ui.user.detail.UserUI() }

        }
    }

    @Composable
    private fun composite(
        node: NodeInfo,
        content: @Composable () -> Unit
    ) {
        val args = remember {
            buildArgsItem(node)
        }
        
        val navArgs = remember {
            navigationArgsInstance { args }
        }

        CompositionLocalProvider(LocalNavigationArgs provides navArgs) {
            content()
        }

        DisposableEffect(node) {
            onDispose {
                saveArgsItem(node, args)
            }
        }
    }

    private fun navigationArgsInstance(body: () -> Any?): NavigationArgs {
        return object : NavigationArgs(body) {}
    }

    private fun buildArgsItem(node: NodeInfo): Any? = when (node.id) {
        "ui.app.assign.AppAssignListingUI" -> ui.app.assign.AppAssignListingArgs().fill(node.args)
        "ui.app.assign.detail.AppDetailUI" -> ui.app.assign.detail.AppDetailArgs().fill(node.args)
        "ui.app.assign.detail.kindergarten.editor.AppKindergartenEditorUI" -> ui.app.assign.detail.AppDetailArgs().fill(node.args)
        "ui.app.assign.detail.kindergarten.preview.AppKindergartenPreviewUI" -> ui.app.assign.detail.AppDetailArgs().fill(node.args)
        "ui.app.assign.detail.wheel.editor.AppEditorWheelUI" -> ui.app.assign.detail.AppDetailArgs().fill(node.args)
        "ui.app.assign.detail.wheel.preview.AppPreviewWheelUI" -> ui.app.assign.detail.AppDetailArgs().fill(node.args)
        "ui.app.rss.AppRssListingUI" -> ui.app.rss.AppRssListingArgs().fill(node.args)
        "ui.app.rss.channel.AppRssListingChannelUI" -> ui.app.rss.AppRssListingArgs().fill(node.args)
        "ui.app.rss.instance.AppRssListingInstanceUI" -> ui.app.rss.AppRssListingArgs().fill(node.args)
        "ui.app.rss.instance.detail.AppRssDetailInstanceUI" -> ui.app.rss.instance.detail.AppRssDetailInstanceArgs().fill(node.args)
        "ui.app.visibility.AppVisibilityListingUI" -> ui.app.visibility.AppVisibilityListingArgs().fill(node.args)
        "ui.campaign.CampaignListingUI" -> ui.campaign.CampaignListingArgs().fill(node.args)
        "ui.campaign.detailv2.editor.CampaignEditorUI" -> ui.campaign.detailv2.editor.CampaignEditorArgs().fill(node.args)
        "ui.campaign.detailv2.preview.CampaignPreviewUI" -> ui.campaign.detailv2.preview.CampaignPreviewArgs().fill(node.args)
        "ui.company.detail.CompanyUI" -> ui.company.detail.CompanyArgs().fill(node.args)
        "ui.console.ConsoleUI" -> ui.console.ConsoleArgs().fill(node.args)
        "ui.dashboard.DashboardUI" -> ui.dashboard.ArgsDashboard().fill(node.args)
        "ui.device.DeviceListingUI" -> ui.device.DeviceListingArgs().fill(node.args)
        "ui.device.detail.editor.DeviceEditorUI" -> ui.device.detail.editor.DeviceEditorArgs().fill(node.args)
        "ui.device.detail.preview.DevicePreviewUI" -> ui.device.detail.DeviceArgs().fill(node.args)
        "ui.hardware.detail.HardwareDetailUI" -> ui.hardware.detail.HardwareDetailArgs().fill(node.args)
        "ui.home.HomeUI" -> ui.ArgsInitial().fill(node.args)
        "ui.license.detail.LicenseDetailUI" -> ui.license.detail.LicenseArgs().fill(node.args)
        "ui.location.LocationListingUI" -> ui.location.LocationListingArgs().fill(node.args)
        "ui.location.detail.LocationUI" -> ui.location.detail.LocationArgs().fill(node.args)
        "ui.login.LoginUI" -> ui.ArgsInitial().fill(node.args)
        "ui.report.campaign.ReportCampaignUI" -> ui.report.campaign.ReportCampaignArgs().fill(node.args)
        "ui.report.device.ReportDeviceAliveUI" -> ui.report.device.ReportDeviceArgs().fill(node.args)
        "ui.report.device.ReportDeviceSystemUI" -> ui.report.device.ReportDeviceArgs().fill(node.args)
        "ui.resource.ResourceListingUI" -> ui.resource.ResourceListingArgs().fill(node.args)
        "ui.resource.detail.ResourceUI" -> ui.resource.detail.ResourceArgs().fill(node.args)
        "ui.resource.editor.VisualEditorUI" -> ui.resource.editor.VisualEditorArgs().fill(node.args)
        "ui.server.detail.ServerUI" -> ui.server.detail.ServerArgs().fill(node.args)
        "ui.user.UserListingUI" -> ui.user.UserListingArgs().fill(node.args)
        "ui.user.detail.UserUI" -> ui.user.detail.UserArgs().fill(node.args)

        else -> null
    }   

    private fun saveArgsItem(node: NodeInfo, argsItem: Any?) {
        when (argsItem) {
            is ui.app.assign.AppAssignListingArgs -> node.args = argsItem.asBundle()
            is ui.app.assign.detail.AppDetailArgs -> node.args = argsItem.asBundle()
            is ui.app.rss.AppRssListingArgs -> node.args = argsItem.asBundle()
            is ui.app.rss.instance.detail.AppRssDetailInstanceArgs -> node.args = argsItem.asBundle()
            is ui.app.visibility.AppVisibilityListingArgs -> node.args = argsItem.asBundle()
            is ui.campaign.CampaignListingArgs -> node.args = argsItem.asBundle()
            is ui.campaign.detailv2.editor.CampaignEditorArgs -> node.args = argsItem.asBundle()
            is ui.campaign.detailv2.preview.CampaignPreviewArgs -> node.args = argsItem.asBundle()
            is ui.company.detail.CompanyArgs -> node.args = argsItem.asBundle()
            is ui.console.ConsoleArgs -> node.args = argsItem.asBundle()
            is ui.dashboard.ArgsDashboard -> node.args = argsItem.asBundle()
            is ui.device.DeviceListingArgs -> node.args = argsItem.asBundle()
            is ui.device.detail.editor.DeviceEditorArgs -> node.args = argsItem.asBundle()
            is ui.device.detail.DeviceArgs -> node.args = argsItem.asBundle()
            is ui.hardware.detail.HardwareDetailArgs -> node.args = argsItem.asBundle()
            is ui.ArgsInitial -> node.args = argsItem.asBundle()
            is ui.license.detail.LicenseArgs -> node.args = argsItem.asBundle()
            is ui.location.LocationListingArgs -> node.args = argsItem.asBundle()
            is ui.location.detail.LocationArgs -> node.args = argsItem.asBundle()
            is ui.report.campaign.ReportCampaignArgs -> node.args = argsItem.asBundle()
            is ui.report.device.ReportDeviceArgs -> node.args = argsItem.asBundle()
            is ui.resource.ResourceListingArgs -> node.args = argsItem.asBundle()
            is ui.resource.detail.ResourceArgs -> node.args = argsItem.asBundle()
            is ui.resource.editor.VisualEditorArgs -> node.args = argsItem.asBundle()
            is ui.server.detail.ServerArgs -> node.args = argsItem.asBundle()
            is ui.user.UserListingArgs -> node.args = argsItem.asBundle()
            is ui.user.detail.UserArgs -> node.args = argsItem.asBundle()

        }
    }
} 
